import { ApiContext } from "../../contexts/ApiContext";
import { useContext } from "react";
import { useMutation } from "react-query";
import { RegionMapping, RegionMappingSubmission } from "../../shared/interfaces/RegionMapping";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useRegionMappingCreation(callbacks?: QueryCallbacks<RegionMapping>) {
  const apiContext = useContext(ApiContext);
  return useMutation({
    ...callbacks,
    mutationKey: ["submitRegionMapping"],
    mutationFn: async (regionMappingSubmission: RegionMappingSubmission) =>
      apiContext.companyApis.createRegionMapping(regionMappingSubmission),
  });
}
